import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import Introduction from "./Introduction";
import MaritalStatus from "./Subsection1";
import Career from "./Subsection2";
import EmploymentStatus from "./Subsection3";
import TypeOfPositions from "./Subsection4";
import BreadcrumbNav from "../../navigation/Breadcrumb";
import RoleCareerResponsesToOtherPrompts from "./Subsection2b";
import TypesOfPositionsResponsesToOtherPrompts from "./Subsection4b";
import BottomNavigation from "../../navigation/BottomNavigation";

interface SpousesPartnersProps {
  toggleSection: (section: string, open?: boolean) => void;
}

const SpousesPartners: FC<SpousesPartnersProps> = ({ toggleSection }) => {
  const { subsection } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [subsection]);

  useEffect(() => {
    toggleSection("Spouses & Partners", true);
  }, [toggleSection])

  useEffect(() => {
    if (subsection === "role-of-career" || subsection === "responses-to-other-prompts-career") {
      toggleSection("Spouses & Partners/Role of spouse/partner career in search and outside offer", true);
    }

    if (subsection === "types-of-positions" || subsection === "responses-to-other-prompts-positions") {
      toggleSection("Spouses & Partners/Type of positions held by spouses/partners", true);
    }
  }, [toggleSection, subsection])

  return (
    <>
      <BreadcrumbNav section="spouses-&-partners" subsection={subsection} />

      <h1>Spouses & Partners</h1>
      {subsection === "introduction" && <Introduction />}
      {subsection === "marital-status" && <MaritalStatus />}
      {subsection === "role-of-career" && <Career />}
      {subsection === "responses-to-other-prompts-career" && <RoleCareerResponsesToOtherPrompts />}
      {subsection === "employment-status" && <EmploymentStatus />}
      {subsection === "types-of-positions" && <TypeOfPositions />}
      {subsection === "responses-to-other-prompts-positions" && <TypesOfPositionsResponsesToOtherPrompts />}

      <BottomNavigation />
    </>
  )
}

export default SpousesPartners;